module.exports = __webpack_public_path__ + "static/media/track-BG-4th-layer-four@2x.0f5c73a0.png";